'use strict'

module.exports = {
  DEFAULT_DEPRECATION_MESSAGE: 'Attention cette API est obsolète, merci de contacter Mappy pour profiter de la dernière mise à jour',
  OK_DEPRECATION_STATUS: 'ok',
  KO_DEPRECATION_STATUS: 'warning',
  KO_DEPRECATED_STATUS: 'deprecated'
}
